import { trigger, animate, style, group, animateChild, query, stagger, transition, state } from '@angular/animations';

export const expandAnimation = trigger('expand', [
  state('', style({ width: '180px' })),
  state('expanded', style({ width: '400px' })),
  transition('* <=> expanded', [animate('500ms ease')])
]);
